import { atom } from 'jotai';
import type { LaneletsCenterLinePoints, Lanes } from './types';
import { atomWithReset } from 'jotai/utils';
import { getLaneletById } from './utils';

export const laneletsCenterLinePointsLoadingAtom = atom(false);

/**
 * APIから取得したレーン情報
 */
export const laneletsCenterLinePointsAtom =
  atomWithReset<LaneletsCenterLinePoints>({
    area_map_version_id: '',
    lanelets_center_line_points: [],
  });

/**
 * APIから取得した配列をレーンIDを key にした Lanes オブジェクトに変換して返す
 */
export const laneletsSelector = atom<Lanes>((get) => {
  const laneletsCenterLinePoints = get(laneletsCenterLinePointsAtom);
  return getLaneletById(laneletsCenterLinePoints);
});
